(() => {
  const ROOTX_URLS = { '2': '/products/rootx-2-lb-kit-funnel', '4': '/products/rootx-4-lb-kit-funnel' };
  const ALWAYS_BUYABLE_HANDLES = new Set(['level-lock-pro','level-lock-matter','level-bolt-matter','level-keypad','level-connect-wifi-bridge']);
  const norm = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const productCache = new Map();
  const currentHandle = () => (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';

  const removeSourceTrustPoint = () => document.querySelectorAll('.kjg-trust-grid > div').forEach(node => { if (norm(node.textContent).includes('source-conscious media')) node.remove(); });

  const styleRootXAlert = () => document.querySelectorAll('.kjg-root-panel[data-kjg-root-panel="4"]').forEach(panel => {
    panel.classList.add('is-rootx-4');
    panel.querySelectorAll('.kjg-alert').forEach(alert => {
      alert.classList.add('kjg-alert--warning');
      alert.style.setProperty('background', '#fff4e5', 'important');
      alert.style.setProperty('background-color', '#fff4e5', 'important');
      alert.style.setProperty('border-left', '7px solid #d97706', 'important');
      alert.style.setProperty('color', '#0b2a3f', 'important');
    });
  });

  const linkRootXImages = () => document.querySelectorAll('.kjg-root-image[data-kjg-root-image]').forEach(card => {
    const size = card.getAttribute('data-kjg-root-image');
    const href = ROOTX_URLS[size] || '/collections/rootx';
    let link = card.querySelector(':scope > a.kjg-root-image-link');
    if (!link) { link = document.createElement('a'); link.className = 'kjg-root-image-link'; while (card.firstChild) link.appendChild(card.firstChild); card.appendChild(link); }
    link.href = href;
    link.setAttribute('aria-label', size === '4' ? 'Open RootX 4 lb kit product page' : 'Open RootX 2 lb kit product page');
    link.style.pointerEvents = 'auto'; card.style.pointerEvents = 'auto';
  });

  const getProductJson = async (url) => {
    const clean = (url || location.pathname).split('?')[0].replace(/\/$/, '') + '.js';
    if (!productCache.has(clean)) productCache.set(clean, fetch(clean, { credentials: 'same-origin' }).then(r => r.ok ? r.json() : null).catch(() => null));
    return productCache.get(clean);
  };

  const selectedValues = picker => [...picker.querySelectorAll('fieldset')].map(fs => (fs.querySelector('input:checked') || {}).value).filter(Boolean);
  const findVariant = (product, values) => product && values.length ? (product.variants || []).find(v => values.every((value, index) => String(v.options[index]) === String(value))) : null;
  const setButtonReady = (button) => {
    button.disabled = false; button.removeAttribute('disabled'); button.removeAttribute('aria-disabled'); button.classList.remove('disabled','is-disabled','sold-out','unavailable');
    button.style.setProperty('opacity','1','important'); button.style.setProperty('filter','none','important'); button.style.setProperty('cursor','pointer','important');
    const text = button.querySelector('.add-to-cart-text__content') || button;
    if (/sold\s*out|unavailable/i.test(text.textContent || '')) text.textContent = 'Add to cart';
  };
  const productButtons = () => document.querySelectorAll('form[action*="/cart/add"] button[name="add"], product-form-component button[name="add"], add-to-cart-component button[name="add"], .product-form__submit');

  const enableVariantUi = async () => {
    const handle = currentHandle();
    const force = ALWAYS_BUYABLE_HANDLES.has(handle);
    document.querySelectorAll('variant-picker').forEach(async picker => {
      picker.querySelectorAll('svg.variant-option__strikethrough').forEach(svg => svg.remove());
      picker.querySelectorAll('input[aria-disabled="true"], input[data-option-available="false"]').forEach(input => {
        input.removeAttribute('aria-disabled'); input.dataset.optionAvailable = 'true';
        const label = input.closest('label'); if (label) { label.classList.remove('disabled','is-disabled','sold-out','unavailable'); label.style.setProperty('text-decoration','none','important'); label.style.setProperty('opacity','1','important'); }
      });
      let canBuy = force;
      const product = await getProductJson(picker.dataset.productUrl || location.pathname);
      const variant = findVariant(product, selectedValues(picker));
      if (variant) {
        document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(input => { input.value = variant.id; });
        canBuy = canBuy || Boolean(variant.available);
      }
      if (canBuy) {
        productButtons().forEach(setButtonReady);
        document.querySelectorAll('quantity-selector-component input[name="quantity"]').forEach(input => input.removeAttribute('disabled'));
        document.querySelectorAll('.accelerated-checkout-block[hidden]').forEach(block => block.removeAttribute('hidden'));
      }
    });
    if (force) productButtons().forEach(setButtonReady);
  };

  const apply = () => { removeSourceTrustPoint(); styleRootXAlert(); linkRootXImages(); enableVariantUi(); };
  const schedule = () => { clearTimeout(schedule.timer); schedule.timer = setTimeout(apply, 50); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true }); else apply();
  window.addEventListener('pageshow', schedule); document.addEventListener('click', schedule, true); document.addEventListener('change', schedule, true);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled','aria-disabled','class','style','data-option-available'] });
})();
